export default __webpack_public_path__ + "static/media/logout.d95c3747.svg";